import { render, staticRenderFns } from "./BplSeasonUserRatingHistory.vue?vue&type=template&id=28e877ec&scoped=true"
import script from "./BplSeasonUserRatingHistory.vue?vue&type=script&lang=js"
export * from "./BplSeasonUserRatingHistory.vue?vue&type=script&lang=js"
import style0 from "./BplSeasonUserRatingHistory.vue?vue&type=style&index=0&id=28e877ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e877ec",
  null
  
)

export default component.exports